import URL from './url'
import http from '@/utils/httpUtils.js'

export default {
  // 查询留堂学生列表
  getDetentionStudentList(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_DETENTION_STUDENT_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 删除留堂学生列表
  deleteDetentionStudent(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DELETE_DETENTION_STUDENT, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 添加留堂学生
  addDetentionStudent(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_ADD_DETENTION_STUDENT, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询放学状态
  getAfterschoolStatus(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_AFTER_SCHOOL_STATUS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 开始放学
  startAfterSchool(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_START_AFTER_SCHOOL, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 班级放学统计
  statAfterSchoolClass(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_STAT_AFTER_SCHOOL_CLASS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询班主任刷脸设备
  getHeaderMasterFaceDevice(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_HEADER_MASTER_FACE_DEVICE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 保存班主任刷脸设备
  saveAdviserDevice(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SAVE_ADVISERDEVICE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询学生刷脸设备
  getStudentFaceDevice(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_STUDENT_FACE_DEVICE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 保存学生刷脸设备
  saveStudentFaceDevice(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SAVE_STUDENT_FACE_DEVICE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询学生等候区刷脸设备
  getWaitingFaceDevice(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_WAITING_FACE_DEVICE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 保存学生等候区刷脸设备
  saveWaitingFaceDevice(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SAVE_WAITING_FACE_DEVICE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询家长等候区设备
  getGuardianDevice(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_GUARDIAN_FACE_DEVICE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 保存家长等候区设备
  saveGuardianDevice(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SAVE_GUARDIAN_FACE_DEVICE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询设备启用时间
  getTodayDeviceEnableTime(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_DEVICE_ENABLE_TIME, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 保存设备启用时间
  saveDeviceEnableTime(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SAVE_DEVICE_ENABLE_TIME, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 保存学生离校时间
  saveNoticeTime(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SAVE_NOTICE_TIME, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 我已到校
  guardianArrival(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_ARRIVED_SCHOOL, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 判断机构下是否有门禁设备
  judgeHasEntranceDevice() {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_JUDGE_HAS_ENTRANCE_DEVICE)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 放学接送通知列表
  getAfterSchoolPickupList(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_AFTER_SCHOOL_PICKUP_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 通知详情的业务扩展
  saveAfterSchoolBizData(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_AFTER_SCHOOL_NOTICE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 新增放学计划
  addDeviceEnableTime(params) {
    return http.post(URL.API_ADD_DEVICE_ENABLE_TIME, params)
  },
  // 查询班级自动放学配置
  getClassPadAfterSchoolConfig(params) {
    return http.get(URL.API_GET_AUTO_CLASS_DEVICE_CONFIG, params)
  },
  // 保存班级自动放学配置
  saveClassPadAfterSchoolConfig(params) {
    return http.post(URL.API_SAVE_AUTO_CLASS_DEVICE_CONFIG, params)
  },
  // 查询班级自动放学配置
  getAutoClassOverConfig(params) {
    return http.get(URL.API_GET_AUTO_CLASS_OVER_CONFIG, params)
  },
  // 保存班级自动放学配置
  saveAutoClassOverConfig(params) {
    return http.post(URL.API_SAVE_AUTO_CLASS_OVER_CONFIG, params)
  },
  // 查询家长到校签到配置
  getStudentLeaveRules(params) {
    return http.get(URL.API_GET_STUDENT_LEAVE_RULES, params)
  },
  // 查询学生放学计划
  getStudentLeavePlan(params) {
    return http.get(URL.API_GET_STUDENT_LEAVE_PLANS, params)
  },
  // 保存家长到校签到配置
  saveStudentLeaveRules(params) {
    return http.post(URL.API_SAVE_STUDENT_LEAVE_RULES, params)
  },
  // 获取班主任刷脸签到的设备数量
  getHeaderMasterFaceDeviceCount(params) {
    return http.get(URL.API_GET_HEADER_MASTER_FACE_DEVICE_COUNT, params)
  },
  // 查询学生进入等候区刷脸设备的数量
  getStudentWaitFaceDeviceCount(params) {
    return http.get(URL.API_GET_STUDENT_WAIT_FACE_DEVICE_COUNT, params)
  },
  // 删除学生放学计划
  deleteDeviceEnableTimeSchedule(params) {
    return http.post(URL.API_STUDENT_LEAVE_PLAN, params)
  },
  // 获取当前时间选修班状态 get
  electiveClassStatus(params) {
    return http.get(URL.API_ELECTIVE_CLASS_STATUS, params)
  },
  // 根据角色获取选修班列表 get
  listElectiveClass(params) {
    return http.get(URL.API_ELECTIVE_CLASS_LIST, params)
  },
  // 选修班开始放学 post
  electiveClassStart(params) {
    return http.post(URL.API_ELECTIVE_CLASS_START, params)
  },
  // 获取当前机构选修班放学开始时间 get
  electiveClassFlexLeaveStartTime(params) {
    return http.get(URL.API_ELECTIVE_GET_LEAVE_TIME, params)
  },
  // 保存当前机构选修班放学开始时间 post
  saveElectiveClassFlexLeaveStartTime(params) {
    return http.post(URL.API_ELECTIVE_SET_LEAVE_TIME, params)
  }
}
